import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  useDisclosure,
} from "@chakra-ui/react";
import { FC, ReactNode } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

interface AccordionComponentProps {
  accordionTitle: string;
  children: ReactNode;
  fontSize?: string;
}

const AccordionComponent: FC<AccordionComponentProps> = ({
  accordionTitle,
  children,
  fontSize = "xl",
}) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Accordion allowToggle>
      <AccordionItem borderTop="none" borderBottom={isOpen ? "" : "none"}>
        <AccordionButton onClick={onToggle} background="gray.100" px="12px">
          <Box
            as="h4"
            flex="1"
            textAlign="left"
            fontSize={fontSize}
            fontWeight="bold"
          >
            {accordionTitle}
          </Box>
          {isOpen ? (
            <ChevronUpIcon boxSize={6} />
          ) : (
            <ChevronDownIcon boxSize={6} />
          )}
        </AccordionButton>

        <AccordionPanel py={5} px={3} background="white">
          {children}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default AccordionComponent;
